export const scopes = {
  createFile: "create:file",
  createLedger: "create:ledger",
  createPayroll: "create:payroll",
  readFile: "read:file",
  readLedger: "read:ledger",
  readMine: "read:mine",
  readPayroll: "read:payroll",
  readPayrollExtended: "read:payroll:extended",
  readXero: "read:xero",
  requestXero: "request:xero",
  superAll: "super:all",
  superFile: "super:file",
  superLedger: "super:ledger",
  superPayroll: "super:payroll",
};

export const audiences = {
  contract: process.env.REACT_APP_API_CONTRACT_AUDIENCE || ("" as string),
  prp: process.env.REACT_APP_API_PRP_AUDIENCE || ("" as string),
  tax: process.env.REACT_APP_API_TAX_AUDIENCE || ("" as string),
};

export type Route = {
  exact?: boolean;
  name: string;
  path: string;
  roles?: any;
  subRoutes?: SubRoute[];
  hidden?: boolean;
};

export type SubRoute = {
  exact?: boolean;
  name?: string;
  path: string;
  roles?: any;
  url?: string;
  hidden?: boolean;
  subRoutes?: SubRoute[];
};

const routes: Route[] = [
  {
    name: "Accounting",
    path: "/accounting",
    roles: {
      [audiences.prp]: [scopes.readXero],
    },
    subRoutes: [
      {
        name: "Employees",
        path: "/employees",
        roles: {
          [audiences.prp]: [scopes.readLedger],
        },
      },
      {
        path: "/employees/:employee",
      },
      {
        name: "Payrolls",
        path: "/payrolls",
        roles: {
          [audiences.prp]: [scopes.readPayroll],
        },
      },
      {
        path: "/payrolls/:payroll",
        roles: {
          [audiences.prp]: [scopes.readPayroll],
        },
      },
      {
        name: "Review Lines",
        path: "/review-lines",
        roles: {
          [audiences.prp]: [scopes.readXero, scopes.createLedger],
        },
      },
      {
        name: "Tools",
        path: "/tools",
      },
    ],
  },
  {
    name: "Me",
    path: "/me",
    roles: {
      [audiences.prp]: [scopes.readMine],
      [audiences.tax]: [scopes.readMine],
    },
    subRoutes: [
      {
        name: "Account",
        path: "/account",
        roles: {
          [audiences.prp]: [scopes.readMine],
        },
      },
      {
        name: "Documents",
        path: "/documents",
        roles: {
          [audiences.tax]: [scopes.readMine],
        },
      },
      {
        name: "Cinode",
        path: "",
        url: process.env.REACT_APP_CINODE_URL,
        hidden: true,
      },
    ],
  },
  {
    name: "Legal",
    path: "/legal",
    roles: {
      [audiences.contract]: [scopes.superAll],
    },
    subRoutes: [
      {
        name: "Contracts",
        path: "/contracts",
        // subRoutes: [
        //   {
        //     name: "Template admin",
        //     path: "/templates",
        //   },
        //   {
        //     path: "/templates/:id",
        //   },
        //   {
        //     path: "/templates/new",
        //     hidden: true,
        //   },
        // ],
      },
      {
        path: "/contracts/:id",
      },
      {
        path: "/contracts/new",
        hidden: true,
      },
      {
        path: "/contracts/pre",
        hidden: true,
      },
      {
        name: "Custom contract",
        path: "/contracts/custom_contract",
        hidden: true,
      },
      {
        name: "Templates",
        path: "/templates",
      },
      {
        path: "/templates/:id",
      },
      {
        path: "/templates/new",
        hidden: true,
      },
    ],
  },
];

export default routes;
